import {
    SET_COMPLIANCE_REPORT_GRID_DATA,
    SET_COMPLIANCE_REPORT_TABLE_EXCEL,
    SET_COMPLIANCE_REPORT_FILTER_DATA,
    SET_COMPLIANCE_MODIFICATION_REPORT,
    SET_APPROVER_UPDATES_GRID_DATA,
    SET_COMPLIANCE_AUDIT_EXPORT_EXCEL
} from "./ComplainceReportType"

const initialState = {
    complianceReportGridData: null,
    complianceReportTableExcel: null,
    complianceReportFilterData: null,
    complianceModificationReport: null,
    approverUpdatesGridData: null,
    complianceAuditExportExcel: null
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_COMPLIANCE_REPORT_GRID_DATA:
            return {
                ...state,
                complianceReportGridData: action.complianceReportGridData
            };
        case SET_COMPLIANCE_REPORT_TABLE_EXCEL:
            return {
                ...state,
                complianceReportTableExcel: action.complianceReportTableExcel
            }
        case SET_COMPLIANCE_REPORT_FILTER_DATA:
            return {
                ...state,
                complianceReportFilterData: action.complianceReportFilterData
            }
        case SET_COMPLIANCE_MODIFICATION_REPORT:
            return {
                ...state,
                complianceModificationReport: action.complianceModificationReport
            }
        case SET_APPROVER_UPDATES_GRID_DATA:
            return {
                ...state,
                approverUpdatesGridData: action.approverUpdatesGridData
            }  
        case SET_COMPLIANCE_AUDIT_EXPORT_EXCEL:
            return {
                ...state,
                complianceAuditExportExcel: action.complianceAuditExportExcel
            }     
        default:
            return state;
    }
};

export default reducer;